import React from 'react';
import { addNotification } from 'reapop';
import { FormattedMessage } from 'react-intl';
import * as types from 'constants/ActionTypes';
import * as Api from 'utils/Api';

function requestCreate() {
  return {
    type: types.CREATE_ENTITY_REQUEST,
  };
}

function requestCreateSuccess(res) {
  return {
    type: types.CREATE_ENTITY_REQUEST_SUCCESS,
    res,
  };
}

function requestCreateFailure(err) {
  return {
    type: types.CREATE_ENTITY_REQUEST_FAILURE,
    err,
  };
}

export function create(entity, data, action) {
  return (dispatch, getState) => {
    dispatch(requestCreate());
    const { loginReducer: { user: { token } }, WebValuesReducer: { valuesByKey } } = getState();

    const config = { entity, data, headers: { Authorization: `Bearer ${token}` } };

    Api.create(config)
      .then((res) => {
        dispatch(requestCreateSuccess(res.data));
        if (valuesByKey !== undefined &&
          valuesByKey['Message.EmployeeMasterCourse'] !== undefined &&
          valuesByKey['Message.EmployeeMasterCourse'].Value === 'true' &&
          entity === 'EmployeeMasterCourse'
        ) {
          const mailConfig = {
            url: '/api/employeeMasterCourse/SendEmail',
            headers: { Authorization: `Bearer ${token}` },
            method: 'POST',
            data: res.data.EmployeeMasterCourseID,
          };
          Api.custom(mailConfig);
          dispatch(addNotification({
            title: <FormattedMessage id="notification.create.title" />,
            message: <FormattedMessage id="notification.create.contact.hr" />,
            status: 'success',
            dismissible: true,
            dismissAfter: 6000,
          }));
        } else {
          dispatch(addNotification({
            title: <FormattedMessage id="notification.create.title" />,
            message: <FormattedMessage id="notification.create.message" />,
            status: 'success',
            dismissible: true,
            dismissAfter: 4000,
          }));
        }
        action && dispatch(action(res.data));
      })
      .catch((err) => {
        const message = err.message && err.message.startsWith('Aðgangur leyfir ekki') ?
          <FormattedMessage id="notification.error.auth" /> : err.message;
        dispatch(addNotification({
          title: <FormattedMessage id="notification.error.title" />,
          // message: err.message || 'Villa kom upp við að stofna færslu í kjarna',
          message,
          status: 'error',
          dismissible: true,
          dismissAfter: 0,
        }));
        dispatch(requestCreateFailure(err));
      });
  };
}

function requestSave() {
  return {
    type: types.SAVE_ENTITY_REQUEST,
  };
}

function requestSaveSuccess(res) {
  return {
    type: types.SAVE_ENTITY_REQUEST_SUCCESS,
    res,
  };
}

function requestSaveFailure(err) {
  return {
    type: types.SAVE_ENTITY_REQUEST_FAILURE,
    err,
  };
}


export function save(entity, data, action) {
  return (dispatch, getState) => {
    dispatch(requestSave());
    const { loginReducer: { user: { token } } } = getState();

    const config = { entity, data, headers: { Authorization: `Bearer ${token}` } };

    Api.save(config)
      .then((res) => {
        dispatch(requestSaveSuccess(res.data));
        dispatch(addNotification({
          title: <FormattedMessage id="notification.save.title" />,
          message: <FormattedMessage id="notification.save.message" />,
          status: 'success',
          dismissible: true,
          dismissAfter: 4000,
        }));
        action && dispatch(action());
      })
      .catch((err) => {
        const message = err.message && err.message.startsWith('Aðgangur leyfir ekki') ?
          <FormattedMessage id="notification.error.auth" /> : err.message;
        dispatch(addNotification({
          title: <FormattedMessage id="notification.error.title" />,
          // message: err.message || 'Villa kom upp við að vist færslu í kjarna',
          message,
          status: 'error',
          dismissible: true,
          dismissAfter: 0,
        }));
        dispatch(requestSaveFailure(err));
      });
  };
}

function requestDelete() {
  return {
    type: types.DELETE_ENTITY_REQUEST,
  };
}

function requestDeleteSuccess(res) {
  return {
    type: types.DELETE_ENTITY_REQUEST_SUCCESS,
    res,
  };
}

function requestDeleteFailure(err) {
  return {
    type: types.DELETE_ENTITY_REQUEST_FAILURE,
    err,
  };
}


export function remove(entity, data, action) {
  return (dispatch, getState) => {
    dispatch(requestDelete());
    const { loginReducer: { user: { token } } } = getState();

    const config = { entity, data, headers: { Authorization: `Bearer ${token}` } };

    Api.remove(config)
      .then((res) => {
        dispatch(requestDeleteSuccess(res.data));
        dispatch(addNotification({
          title: <FormattedMessage id="notification.delete.title" />,
          message: <FormattedMessage id="notification.delete.message" />,
          status: 'success',
          dismissible: true,
          dismissAfter: 4000,
        }));
        action && dispatch(action());
      })
      .catch((err) => {
        const message = err.message && err.message.startsWith('Aðgangur leyfir ekki') ?
          <FormattedMessage id="notification.error.auth" /> : err.message;
        dispatch(addNotification({
          title: <FormattedMessage id="notification.error.title" />,
          // message: err.message || 'Villa kom upp við að vist færslu í kjarna',
          message,
          status: 'error',
          dismissible: true,
          dismissAfter: 0,
        }));
        dispatch(requestDeleteFailure(err));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/EntityCRUD.js